import { initializeTomSelect } from "../tom_select"
import BaseFilter from "./base_filter"
import { createFormGroup, createSelect, createSummary } from "./dom"

export default class MultipleSelectionFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.input = createSelect(this.definition.options || [], {
      className: "form-control",
      multiple: true,
    })
    this.element.append(createFormGroup(this.definition.title, this.input))
    this.appendApplyButton()

    return this.element
  }

  connect() {
    this.tomSelect = initializeTomSelect(this.input, {
      noResultsText: this.context.translations.noResults,
      prompt: this.definition.prompt,
    })
  }

  disconnect() { this.tomSelect?.destroy() }

  read() {
    const values = Array.from(this.input.selectedOptions, (option) => option.value)
    return this.result(values, values.length > 0)
  }

  summary(value) {
    const count = Array.isArray(value) ? value.length : 0
    return createSummary(this.definition.title, count)
  }
}
